import React, { useState } from "react";


const Listcomp = (props) => {

    const [line, setLine] = useState (false);

    const cutIt = () => {
        setLine(true);
    }

    return (
        <>
            <div className="d-flex ">
                <div onClick={cutIt} style={{cursor : 'pointer'}}>😈</div>
                <div style={{textDecoration : line ? 'line-through' : 'none'}}>{props.text}</div>
            </div>
        </>
    )

}

export default Listcomp;